import "./App.css";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import Info from "./pages/Info";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Experience from "./pages/Experience";
import DotRing from "./components/DotRing";
import Skills from "./pages/Skills";
import Contact from "./pages/Contact";
import E404 from "./pages/E404";

function App() {
  return (
    <BrowserRouter>
      <DotRing />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        {/* <Route path="/:info" component={Info} /> */}
        <Route path="/projects" component={Projects} />
        <Route path="/about" component={About} />
        <Route path="/experience" component={Experience} />
        <Route path="/skills" component={Skills} />
        <Route path="/contact" component={E404} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
